import { useQuery } from '@tanstack/react-query';
/**
 * A wrapper around useQuery that just provides the useQuery, but with the
 * ability to update in the future to use a different query library.
 */
const useAppQuery = useQuery;

export default useAppQuery;
